export function createMap() {
  console.log('create map');
  mapboxgl.accessToken =
    'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';
  let map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/latimes/ckhgrxw720lax1aom3e6b5hyc', // stylesheet location
    center: [-118.1976, 34.085739], // starting position [lng, lat]
    zoom: 9, // starting zoom
    interactive: false,
  });
  return map;
}

let routes = {
  type: 'FeatureCollection',
  features: window.MAP_DATA.features.filter(
    (f) => f.geometry.type === 'LineString'
  ),
};
let points = {
  type: 'FeatureCollection',
  features: window.MAP_DATA.features.filter(
    (f) => f.geometry.type === 'Point' && ![4, 7].includes(f.properties.slide)
  ),
};
let specialPoints = {
  type: 'FeatureCollection',
  features: window.MAP_DATA.features.filter(
    (f) => f.geometry.type === 'Point' && f.properties.slide === 4
  ),
};
let routePoints = {
  type: 'FeatureCollection',
  features: window.MAP_DATA.features.filter(
    (f) => f.geometry.type === 'Point' && f.properties.slide === 7
  ),
};
let polygons = {
  type: 'FeatureCollection',
  features: window.MAP_DATA.features.filter(
    (f) => f.geometry.type === 'Polygon'
  ),
};

export function addMarkers() {
  console.log(routes, points, specialPoints, polygons);

  // routes
  window.map.addSource('routes', {
    type: 'geojson',
    data: routes,
  });

  window.map.addLayer({
    id: 'routes-layer',
    type: 'line',
    source: 'routes',
    layout: {
      'line-round-limit': 5,
    },
    paint: {
      'line-color': '#DD340E',
      'line-width': {
        base: 5,
        stops: [
          [9, 0],
          [10, 3],
          [12, 5],
        ],
      },
      'line-opacity': [
        'case',
        ['boolean', ['feature-state', 'active'], false],
        1,
        0.5,
      ],
    },
  });

  // points
  window.map.addSource('points', {
    type: 'geojson',
    data: points,
  });

  window.map.addLayer({
    id: 'points-layer',
    type: 'symbol',
    source: 'points',
    paint: {
      'icon-opacity': [
        'case',
        ['boolean', ['feature-state', 'active'], false],
        1,
        0.5,
      ],
      // 'text-color': '#9fb814',
      'text-color': '#DD340E',
      'text-halo-color': '#fff',
      'text-halo-width': [
        'case',
        ['boolean', ['feature-state', 'active'], false],
        3,
        0.5,
      ],
      'text-opacity': [
        'case',
        ['boolean', ['feature-state', 'active'], false],
        1,
        0.5,
      ],
    },
    layout: {
      'icon-image': '{icon}',
      'icon-size': {
        base: 1,
        stops: [
          [11, 0],
          [12, 1],
        ],
      },
      'text-field': ['get', 'label'],
      'text-variable-anchor': ['top'],
      'text-font': ['Rubik Bold Italic'],
      'text-size': {
        base: 0,
        stops: [
          [12, 0],
          [15, 18],
        ],
      },
      'text-padding': 23,
      'icon-allow-overlap': true,
      'text-allow-overlap': true,
      'icon-ignore-placement': true,
      'text-optional': false,
    },
  });

  // points
  window.map.addSource('routePoints', {
    type: 'geojson',
    data: routePoints,
  });

  window.map.addLayer({
    id: 'routePoints-layer',
    type: 'symbol',
    source: 'routePoints',
    paint: {
      'text-color': '#DD340E',
      'text-halo-color': '#fff',
      'text-halo-width': [
        'case',
        ['boolean', ['feature-state', 'active'], false],
        3,
        0.5,
      ],
      'text-opacity': [
        'case',
        ['boolean', ['feature-state', 'active'], false],
        1,
        0.5,
      ],
    },
    layout: {
      'text-field': ['get', 'label'],
      'text-variable-anchor': ['top'],
      'text-font': ['Rubik Bold Italic'],
      'text-size': {
        base: 0,
        stops: [
          [10, 0],
          [11, 18],
          [15, 18],
        ],
      },
      'text-padding': 23,
      'text-optional': false,
    },
  });

  // for growing up area label
  window.map.addSource('specialPoints', {
    type: 'geojson',
    data: specialPoints,
  });

  window.map.addLayer({
    id: 'points-layer-b',
    type: 'symbol',
    source: 'specialPoints',
    paint: {
      // 'text-color': '#9fb814',
      'text-color': '#6B7C0E',
      'text-halo-color': '#fff',
      'text-halo-width': [
        'case',
        ['boolean', ['feature-state', 'active'], false],
        3,
        3,
      ],
      'text-opacity': [
        'case',
        ['boolean', ['feature-state', 'active'], false],
        1,
        0.5,
      ],
    },
    layout: {
      'text-field': ['get', 'label'],
      'text-variable-anchor': ['center'],
      'text-font': ['Rubik Bold Italic'],
      'text-size': {
        base: 0,
        stops: [
          [12, 0],
          [15, 18],
        ],
      },
      'text-padding': 23,
    },
  });

  // areas
  window.map.addSource('polygons', {
    type: 'geojson',
    data: polygons,
  });

  window.map.addLayer(
    {
      id: 'polygons-layer',
      type: 'fill',
      source: 'polygons',
      paint: {
        'fill-opacity': [
          'case',
          ['boolean', ['feature-state', 'active'], false],
          0.6,
          0.3,
        ],
        'fill-color': '#dce5b4',
      },
    },
    'road-simple'
  );

  window.map.addLayer({
    id: 'polygons-outline-layer',
    type: 'line',
    source: 'polygons',
    paint: {
      'line-color': '#5b6054',
      'line-width': {
        base: 3,
        stops: [
          [11, 0],
          [12, 3],
        ],
      },
      'line-dasharray': [3, 2],
      'line-opacity': [
        'case',
        ['boolean', ['feature-state', 'active'], false],
        1,
        0.5,
      ],
    },
  });
}

export function showMarkers(slide) {
  // reset them all
  routes.features.forEach((f) => {
    window.map.setFeatureState(
      {
        source: 'routes',
        id: f.id,
      },
      {
        active: false,
      }
    );
  });

  points.features.forEach((f) => {
    window.map.setFeatureState(
      {
        source: 'points',
        id: f.id,
      },
      {
        active: false,
      }
    );
  });

  specialPoints.features.forEach((f) => {
    window.map.setFeatureState(
      {
        source: 'specialPoints',
        id: f.id,
      },
      {
        active: false,
      }
    );
  });

  routePoints.features.forEach((f) => {
    window.map.setFeatureState(
      {
        source: 'routePoints',
        id: f.id,
      },
      {
        active: false,
      }
    );
  });

  polygons.features.forEach((f) => {
    window.map.setFeatureState(
      {
        source: 'polygons',
        id: f.id,
      },
      {
        active: false,
      }
    );
  });

  // now show based on slide
  if (parseInt(slide) === 4) {
    window.map.setFeatureState(
      {
        source: 'polygons',
        id: parseInt(slide),
      },
      {
        active: true,
      }
    );
    window.map.setFeatureState(
      {
        source: 'specialPoints',
        id: parseInt(slide),
      },
      {
        active: true,
      }
    );
  }

  if (parseInt(slide) === 7) {
    window.map.setFeatureState(
      {
        source: 'routes',
        id: routes.features[0].id,
      },
      {
        active: true,
      }
    );
    window.map.setFeatureState(
      {
        source: 'routePoints',
        id: routePoints.features[0].id,
      },
      {
        active: true,
      }
    );
  }

  if ([5, 6, 8, 14, 15].includes(parseInt(slide))) {
    window.map.setFeatureState(
      {
        source: 'points',
        id: parseInt(slide),
      },
      {
        active: true,
      }
    );
  }
}
